import {FC} from 'react'
import {storeBooking} from "../../lib/booking";
import {hjulskifteFlows} from "../../constants/global";
import CheckBox from "../common/Checkbox/Checkbox";


interface Props {
    booking:Booking,
    setBooking:Function
}

const ExtraFields: FC<Props> = ({booking, setBooking}) => {
    const updateField = (e: any) => {
        switch (e.target.name) {
            case 'submission_street':
                booking.submission.address = e.target.value
                break
            case 'submission_postal':
                booking.submission.postal = e.target.value
                break
            case 'submission_city':
                booking.submission.city = e.target.value
                break
        }

        storeBooking(booking, setBooking)
    }

    const handleCheckBox = (box:string, value:any) => {
        booking.submission.time = box
        setBooking({
            ...booking,
        })
    }

    if(booking.submission.type.includes("address")) {
        return (
            <>
                <ul className="wco-order-options_list brand-extra-option">
                    <li className="input-outer chk-box">
                        <div className="li-text">
                            <div className="description">
                                <h3>{booking.submission.name} <abbr className="required" title="krävs">*</abbr></h3>
                                <p className={'mb-2'}>Skriv in bilens adress.</p>
                            </div>
                            <div className="input-outer">
                                <label htmlFor="submission_street">Gata</label>
                                <input id="submission_street" type="text" name="submission_street" placeholder="" value={booking.submission.address} onChange={updateField}/>
                            </div>
                            <div className="input-outer">
                                <label htmlFor="submission_postal">Postnummer</label>
                                <input id="submission_postal" type="text" name="submission_postal" placeholder="" value={booking.submission.postal} onChange={updateField}/>
                            </div>
                            <div className="input-outer">
                                <label htmlFor="submission_city">Stad</label>
                                <input id="submission_city" type="text" name="submission_city" placeholder="" value={booking.submission.city} onChange={updateField}/>
                            </div>
                        </div>
                    </li>
                </ul>
            </>
        )
    }

    if(booking.submission.type.includes("time") && !hjulskifteFlows.includes(booking.service.booking_flow) && booking.service.booking_flow != 'window') {
        return (
            <>
                <ul className="wco-order-options_list brand-extra-option">
                    <li className="input-outer chk-box">
                        <div className="li-text">
                            <div className="description">
                                <h3 className={"required"}>{booking.submission.name}</h3>
                                <p className={'mb-2'}>Välj tid.</p>
                            </div>
                            <div className="input-outer">
                                <CheckBox radio={true} title={'07:00-09:00'} active={booking.submission.time === '07:00-09:00'} type={'07:00-09:00'} handle={handleCheckBox} />
                                <CheckBox radio={true} title={'09:00-12:00'} active={booking.submission.time === '09:00-12:00'} type={'09:00-12:00'} handle={handleCheckBox}/>
                                <CheckBox radio={true} title={'12:00-16:00'} active={booking.submission.time === '12:00-16:00'} type={'12:00-16:00'} handle={handleCheckBox}/>
                            </div>
                        </div>
                    </li>
                </ul>
            </>
        )
    }

    return
};

export default ExtraFields
